"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Alerts;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Alerts(props) {
    var _props$alerts = props.alerts,
        alerts = _props$alerts === undefined ? [] : _props$alerts;


    if (!alerts.length) {
        return null;
    }

    return _react2.default.createElement(
        "div",
        null,
        alerts.map(function (alert, idx) {
            var message = alert.message,
                _alert$type = alert.type,
                type = _alert$type === undefined ? "danger" : _alert$type;

            return _react2.default.createElement(
                _reactBootstrap.Alert,
                { key: idx, bsStyle: type },
                message
            );
        })
    );
}
//# sourceMappingURL=Alerts.js.map